<template>
    <div class="modal fade" :id="'updateUninformedModal' + _uid" role="dialog"
         aria-labelledby="updateUninformedModalLabel" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateUninformedModalLabel">{{ $t('registers.participants.edit') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="col-md-12 bmd-form-group">
                            <div class="font-weight-bold">{{ $t('sentEmails.gridHeaders.Notified') }}</div>
                            <input type="checkbox" class="form-control" :name="'Notified'+_uid"
                                   :data-vv-as="$t('sentEmails.gridHeaders.Notified')"
                                   v-model="model.otherNotification"/>
                        </div>
                        <div class="col-md-12 bmd-form-group" v-if="model.otherNotification">
                            <div class="font-weight-bold">{{ $t('sentEmails.gridHeaders.NotifiedAt') }}</div>
                            <DatePicker
                                v-model="model.otherNotificationAt"
                                format="dd.MM.yyyy H:mm"
                            ></DatePicker>
                        </div>
                        <div class="col-md-12 bmd-form-group" >
                            <div class="font-weight-bold">{{ $t('sentEmails.gridHeaders.Note') }}</div>
                            <input type="text" class="form-control" v-model="model.otherNotificationNote">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" @click="save" class="btn btn-primary">{{ $t('buttons.save.btnText') }}</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('buttons.cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "../../datepicker/DateTimePicker";
import {UpdateNotification} from "../../../models/models";

export default {
    components: {
        DatePicker
    },
    props: {
        value: {
            type: Object,
            required: false
        },
        show: {
            type: Boolean,
            default: false
        },
        profileManagement: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showEditor: false,
            model: new UpdateNotification(),
        };
    },
    methods: {
        onClose(e, fromBtn) {
            if ((e && e.target.id === `updateUninformedModal${this._uid}`) || fromBtn == true) {
                this.$emit('onClose', {...this.model});
                this.model = new UpdateNotification();
                this.$validator.reset();
            } else {
                $(this.$el).focus();
            }


            //this.$emit('onClose', { ...this.model });
            //this.model = new Participant();
            //this.$validator.reset();
        },
        hide(e) {
            $('#updateUninformedModal' + this._uid).modal('hide');
            //$(this.$el).modal('hide');
        },
        save(){
            this.$http.put('api/notification', this.model).then(response =>{
                if (response){
                    this.$vs.notify({
                        color: 'success',
                        title: this.$t('updateSuccess'),
                        text: ''
                    });
                    this.onSave();
                }
            }).catch(error=>{
                this.$vs.notify({
                    color: 'danger',
                    title: this.$t('notifications.error'),
                    text: this.$helpers.errorText(error)
                });
            }).then(() => {
                this.hide();
            });
        },
        onSave(model) {
            this.$emit('updated', model);
            this.onClose(null, true);
        },
        onCancel() {
            this.onClose(null, true);
        },
        onNomEditModalClose() {

        }
    },
    mounted() {
        //add modal close listener
        $('#updateUninformedModal' + this._uid).on('hidden.bs.modal', this.onClose);
    },
    beforeDestroy() {
        //remove listener
        $('#updateUninformedModal' + this._uid).off('hidden.bs.modal');
    },
    watch: {
        show: function (val) {
            if (val) {
                this.model = new UpdateNotification(this.value);
                this.showEditor = true;
                $('#updateUninformedModal' + this._uid).modal('show');
            } else {
                $('#updateUninformedModal' + this._uid).modal('hide');
            }
        },
        'model.otherNotification':{
            immediate:true,
            handler(val){
                if (!val){
                    this.model.otherNotificationAt = null;
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.bmd-form-group {
    padding-top: 0px !important;
}
</style>
